import {
  BookOpen,
  Building2,
  CalendarCheck,
  ChartBar,
  ChartNoAxesColumnIncreasing,
  ClipboardCheck,
  DollarSign,
  FileSearch,
  FileText,
  HouseCog,
  IdCard,
  UserCog,
  Users
} from 'lucide'

export const MODULE_ICONS = {
  '/client': Building2,
  '/configuration': UserCog,
  '/dossier': Users,
  '/recruitment': FileSearch,
  '/actionPlan': ClipboardCheck,
  '/management': IdCard,
  '/workday': CalendarCheck,
  '/remuneration': DollarSign,
  '/trainings': BookOpen,
  '/researches': FileText,
  '/career': ChartNoAxesColumnIncreasing,
  '/reports': ChartBar,
  '/health': HouseCog
}
